// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail--3HPZRjqyI","changed":"changed--lfefyoUd7"};